/* istanbul ignore file */
import { useMemo } from 'react';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import { useIdentity } from '@zenbusiness/application-commons-identity';

import { getMenuConfig } from '../config';
import { useLogoBuilderConfig } from './webTools/useLogoBuilderConfig';

/**
 * Return the menu config for the current business entity.
 *
 * @param {boolean} isMobile
 * @returns {{
 *  loading: boolean
 *  menu: Array
 * }}
 */
export function useBusinessEntityNav({ isMobile }) {
  const { accountEmail: email } = useIdentity();
  const { businessEntityUuid, entitlements, loading } = useBusinessEntity();

  const { isLBTRTestEnabled, isLBTRTestActive } = useLogoBuilderConfig();
  const enableTaxServices = useExperimentFlag('enable-tax-services', false);
  const enableInsightsUIMFE = useExperimentFlag('enable-insights-ui-mfe', false);

  // Need to memoize the ldFlags if we want to memoize the menu
  const ldFlags = useMemo(() => ({
    isLBTRTestActive,
    isLBTRTestEnabled,
    enableTaxServices,
    enableInsightsUIMFE
  }), [
    isLBTRTestActive,
    isLBTRTestEnabled,
    enableTaxServices,
    enableInsightsUIMFE
  ]);

  const menu = useMemo(() => getMenuConfig({
    businessEntityUuid,
    email,
    entitlements,
    ldFlags,
    isMobile
  }), [
    businessEntityUuid,
    email,
    entitlements,
    ldFlags,
    isMobile
  ]);

  return { loading, menu };
}
